const div = document.createElement("div")

const CACHE_MAX = 2000
const cachePlain = new Map()
const cacheLineBreak = new Map()

/**
 * Strips all of the tags from HTML and returns the text content.
 * By default joins block elements with " | "; with `lineBreak=true`, preserves newlines.
 *
 * Memoizes results per (html, lineBreak) pair — htmlToText is called many times
 * per re-render across the app and the DOM-parse cost dominates. Two bounded
 * Map caches (FIFO eviction at CACHE_MAX) keyed by the input string.
 *
 * @param {string} html
 * @param {boolean} [lineBreak=false]
 * @returns {string}
 */
export function htmlToText(html, lineBreak = false) {
    if (!html || html === "undefined") return ""

    const cache = lineBreak ? cacheLineBreak : cachePlain
    if (typeof html === "string" && cache.has(html)) return cache.get(html)

    div.innerHTML = html

    // Replace block elements (like <p>, <div>, etc.) with newlines
    div.querySelectorAll("p, div, br").forEach((el) => el.insertAdjacentText("afterend", "\n"))

    let result = div.innerText

    if (lineBreak) {
        result = div.innerText
    } else {
        result = div.innerText.replace(/\n+/g, " | ").trim()
    }
    if (result.endsWith("|")) {
        result = result.slice(0, -2)
    }

    if (typeof html === "string") {
        cache.set(html, result)
        if (cache.size > CACHE_MAX) cache.delete(cache.keys().next().value)
    }

    return result
}

export function __resetHtmlToTextCachesForTests() {
    cachePlain.clear()
    cacheLineBreak.clear()
}
